import React from 'react';
import PropTypes from 'prop-types';
import Filter from './Filter';
import {flexRender} from '@tanstack/react-table';

const Header = ({
  properties,
  table,
  columnResizeMode,
  pinLeftWidth,
  colClassName,
  customPinning,
  pinningHandler,
  style,
  title,
}) => {
  // header could be element or string, render as title if string
  const hoverTitle = title ?
    title :
    typeof properties.column.columnDef.header === 'string' ? properties.column.columnDef.header : null;

  return <th
    key={properties.id}
    colSpan={properties.colSpan ? properties.colSpan : 1}
    style={{
      verticalAlign: 'middle',
      width: isNaN(properties.getSize()) ? 0 : properties.getSize(),
      display: properties.getSize() == 0 ? 'none' : '',
      ...style,
      ...(properties.column.getIsPinned() && {left: pinLeftWidth}),
    }}
    className={colClassName ? colClassName : ''}
    title={hoverTitle}
  >
    {properties.isPlaceholder ? null :
      <span>
        {properties.column.getCanResize() &&
          <div
            {...{
              onMouseDown: properties.getResizeHandler(),
              onTouchStart: properties.getResizeHandler(),
              className: `resizer ${
                properties.column.getIsResizing() ? 'isResizing' : ''
              }`,
              style: {
                transform:
                  columnResizeMode === 'onEnd' &&
                  properties.column.getIsResizing()
                    ? `translateX(${
                      table.getState().columnSizingInfo.deltaOffset
                    }px)`
                    : '',
              },
            }}
          />
        }
        <div style={{textalign: top}}
          {...{
            className: properties.column.getCanSort()
              ? 'cursor-pointer select-none'
              : '',
            onClick: properties.column.getToggleSortingHandler(),
          }}
        >
          {flexRender(
            properties.column.columnDef.header,
            properties.getContext(),
          )}
          {{
            asc: ' 🔼',
            desc: ' 🔽',
          }[properties.column.getIsSorted()] ?
            {
              asc: ' 🔼',
              desc: ' 🔽',
            }[properties.column.getIsSorted()] : null}

          {customPinning &&
            <button
              onClick={() => pinningHandler(properties.id, !properties.column.columnDef.isPinned)}
              className="mx-2 text-xs text-white"
            >
              {properties.column.columnDef.isPinned ? 'x' : 'pin'}
            </button>
          }
        </div>
        <div>
          {properties.column.getCanFilter() ? (
            <Filter column={properties.column} table={table} />
          ) : null}
        </div>
      </span>
    }
  </th>;
};

Header.propTypes = {
  properties: PropTypes.shape({
    id: PropTypes.string,
    colSpan: PropTypes.number,
    isPlaceholder: PropTypes.bool,
    getResizeHandler: PropTypes.func,
    column: PropTypes.shape({
      columnDef: PropTypes.object,
      getCanSort: PropTypes.func,
      getToggleSortingHandler: PropTypes.func,
      getIsSorted: PropTypes.func,
      getCanFilter: PropTypes.func,
      getIsPinned: PropTypes.func,
      getIsResizing: PropTypes.func,
      getCanResize: PropTypes.func,
    }),
    getSize: PropTypes.func,
    getContext: PropTypes.func,
  }),
  columnResizeMode: PropTypes.string,
  pinLeftWidth: PropTypes.number,
  table: PropTypes.object,
  colClassName: PropTypes.string,
  customPinning: PropTypes.bool,
  pinningHandler: PropTypes.func,
  style: PropTypes.object,
  title: PropTypes.string,
};

export default Header;
